var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:menu-fold-2-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 4.375L11.25 10.625L5 16.875V4.375ZM26.25 25V22.5H3.75V25H26.25ZM26.25 16.25V13.75H15V16.25H26.25ZM26.25 7.5V5H15V7.5H26.25Z",
    fill: "#3C2464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFold);
export default __webpack_public_path__ + "static/media/menuFold.be90a6ea4010ac15ecae97c2a3a3bf89.svg";
export { ForwardRef as ReactComponent };